import React, { Component } from 'react'
import { Upload } from 'hlj-components'
import { message } from 'hljd'
import style from './style.module.less'
import VerticalImgUploader from '@common/VerticalImgUploader'

export default class extends Component {
  onDeleted = type => () => {
    this.props.onChange({
      ...this.props.value,
      [type]: ''
    })
  }

  onCliped = type => image => {
    const { clipUrl, pixel } = image
    const { width, height } = pixel
    const params = {}
    if (type == 'cover_url') {
      params['cover_width'] = width
      params['cover_height'] = height
    } else {
      params['vertical_width'] = width
      params['vertical_height'] = height
    }
    this.props.onChange({
      ...this.props.value,
      ...params,
      [type]: clipUrl
    })
  }

  render() {
    const { value } = this.props
    const { cover_url, vertical_cover_url } = value || {}
    return (
      <>
        <Upload
          style={{ marginRight: 20 }}
          link={cover_url}
          onDelete={this.onDeleted('cover_url')}
          clipabled
          onCliped={this.onCliped('cover_url')}
          aspect={988 / 616}
          filters={{
            mime_types: [
              {
                title: 'images files',
                extensions: 'jpg,gif,png,jpeg,bmp'
              }
            ],
            max_file_size: '15mb'
          }}
          description={
            <div className={style.coverUploader}>
              <p>横图</p>
              <p>988*616px</p>
            </div>
          }
          onBeforeUp={async (up, file) => {
            return new Promise((resolve, reject) => {
              Upload.checkSize(file, ({ width, height }) => {
                if (width < 988 || height < 616) {
                  message.warn(`宽>=988，高>=616`)
                  reject(false)
                } else {
                  resolve(true)
                }
              })
            })
          }}
        />
        <VerticalImgUploader
          title="选取场地横图"
          horizonImg={cover_url}
          value={vertical_cover_url}
          width={180}
          height={180}
          onDelete={this.onDeleted('vertical_cover_url')}
          onCliped={this.onCliped('vertical_cover_url')}
          aspect={1 / 1}
          filters={{
            mime_types: [
              {
                title: 'images files',
                extensions: 'jpg,gif,png,jpeg,bmp'
              }
            ],
            max_file_size: '15mb'
          }}
          description={
            <div className={style.coverUploaderVertical}>
              <p>竖图</p>
              <p>540*540px</p>
            </div>
          }
          uploadConfig={{
            onBeforeUp: async (file, up) => {
              return new Promise((resolve, reject) => {
                Upload.checkSize(file, ({ width, height }) => {
                  if (width < 540 || height < 540) {
                    message.warn(`宽>=540, 高>=540`)
                    reject(false)
                  } else {
                    resolve(true)
                  }
                })
              })
            }
          }}
        />
      </>
    )
  }
}

export const CoversUploaderValidator = (rule, value, callback) => {
  const { cover_url, vertical_cover_url } = value
  if (!cover_url && !vertical_cover_url) {
    callback('请上传横图和竖图')
  }
  if (!cover_url) {
    callback('请上传横图')
  }
  if (!vertical_cover_url) {
    callback('请上传竖图')
  }
  callback()
}
